import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import find from 'lodash/find';
import { useAction } from 'hooks';
import VisitNotesMessenger from 'modules/Visit/partials/VisitNotesMessenger';
import Account from 'modules/Account';
import * as PatientSelectors from 'modules/Patient/selectors';
import { storeNotes } from 'modules/Patient/actions';
const VisitNotesPage = ({ visit })=>{
    const patientProfile = useSelector(Account.selectors.patientProfile);
    const sharingRequests = useSelector(PatientSelectors.sharingRequests);
    const onStoreNotesAction = useAction(storeNotes);
    const { clinicId } = visit.metadata;
    const sharingRequest = find(sharingRequests, (sr)=>sr.clinic && sr.clinic.id === clinicId);
    const onStoreNotes = (notes, phiSet, phiSetDocumentId, phisetVisitId, visitMetadata = {})=>{
        onStoreNotesAction(notes, phiSet, phiSetDocumentId, phisetVisitId, patientProfile, sharingRequest, visitMetadata);
    };
    return /*#__PURE__*/ _jsx(VisitNotesMessenger, {
        phisetVisitId: visit.phisetVisitId,
        mode: "PWD",
        isMobile: true,
        onStoreNotes: onStoreNotes
    });
};
export default VisitNotesPage;
